module.exports = __webpack_public_path__ + "img/alert.f020751a.png";